export default __webpack_public_path__ + "static/media/05.179830a5.jpg";